import styled from "styled-components";
import Theme from "../../../../Styles/Themes";
import config from "../../../../Config/config.json"

export const Container = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    cursor: pointer;
    border-radius: 25px;
    padding: 5px;
    transition: 1s;
    text-decoration: none;
    &:hover {
        background: #3E78AA;
    }
`;

export const ProfileImage = styled.img`
    display: flex;
    width: 80px;
    height: 80px;
    border-radius: 50px
`;

export const Name = styled.label`
    display: flex;
    color: #fff;
    font-weight: 700;
    font-size: ${Theme[config.theme].font.labels[config.fontSize].size};
    line-height: ${Theme[config.theme].font.labels[config.fontSize].line_height};
    cursor: pointer;
`